
import { MsalService } from '@azure/msal-angular';


export function appInitializer(msal: MsalService) {
    return async () => {
      await msal.instance.initialize();
    };
  }
  